import {useParams} from 'react-router-dom';

import {PersonnelDocumentTitle} from 'src/app/personnel/personnelHelpers';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {
  ModuleEnum,
  PermissionOperationEnum,
  UserTypeEnum,
} from 'src/api/ProactApiClient';
import type {PersonnelViewType} from 'src/shared/constants/ViewTypes';
import {PersonnelForm} from 'src/app/personnel/PersonnelForm/PersonnelForm';
import type {ViewModeType} from 'src/shared/services/RouterService/IRouteService';
import {VendorPendingPersonnelRouteService} from 'src/shared/services/RouterService/VendorPendingPersonnelRouteService';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const VendorPersonnelPendingReviewEditPage = () => {
  useSetDocumentTitle(PersonnelDocumentTitle);
  const {personnelId, vendorId, view} = useParams();

  const mode: ViewModeType = 'edit';
  const router = new VendorPendingPersonnelRouteService(false, mode, {
    view: view as PersonnelViewType,
    vendorId: vendorId,
  });

  return (
    <PersonnelForm
      mode={mode}
      userType={UserTypeEnum.Contractor}
      vendorId={+vendorId!}
      id={+personnelId!}
      view={view as PersonnelViewType}
      enableEdit={true}
      router={router}
    />
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.VendorPendingPersonnelEdit(
    ':personnelId',
    ':vendorId',
    ':view'
  ),
  element: <VendorPersonnelPendingReviewEditPage />,
  module: ModuleEnum.Personnel,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});

export default VendorPersonnelPendingReviewEditPage;
